import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Api from "../../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const validationSchema = yup.object().shape({
  nome_pt: yup.string().nullable().required("Nome da categoria obrigatório"),
  nome_en: yup.string().nullable().required("Nome da categoria obrigatório"),
  nome_es: yup.string().nullable().required("Nome da categoria obrigatório"),
});

export default function EditCategoria({
  data,
  setOpenModalCategoriaEdit,
  loadCardapio,
  loadCardapioCategorias,
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitSuccessful, errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    setValue("id", data.id);
    setValue("nome_pt", data.nome_pt);
    setValue("nome_en", data.nome_en);
    setValue("nome_es", data.nome_es);
  }, []);

  const onSubmit = (dataTopic) => {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    Api.post("/cardapio/categorias/edit", dataTopic, axiosConfig)
      .then((response) => {
        if (response.data.status == "success") {
          swal("Sucesso!", response.data.message, "success");
          loadCardapioCategorias();
          loadCardapio();
          setOpenModalCategoriaEdit(false);
          reset({ name: "", category: "" });
        } else {
          swal("Erro!", response.data.message, "error");
        }
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
      });
  };

  return (
    <>
      <h2>Editar Categoria</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container className="form">
          <Tabs>
            <TabList>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} />
              </Tab>
            </TabList>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_pt")} />
                <span className="error">{errors.nome_pt?.message}</span>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_en")} />
                <span className="error">{errors.nome_en?.message}</span>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_es")} />
                <span className="error">{errors.nome_es?.message}</span>
              </Grid>
            </TabPanel>
          </Tabs>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={() => {
              setOpenModalCategoriaEdit(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
